<template>
  <form @submit.prevent="submit">
    <div class="card border-0 mb-4">
      <div class="card-body">
          <div v-if="showSelect" class="row">
              <div class="col-12">
                  <div class="form-group mb-0">
                      <label for="type_of_realty">Typ nemovitosti</label>
                      <select class="custom-select border-radius-20" id="type_of_realty" name="type_of_realty"
                              @change="fields.property_type = $event.target.value">
                          <option
                              :value="'unit'"
                              :selected="fields.property_type === 'unit'"
                              >
                              Jednotka
                          </option>
                          <option
                              :value="'building'"
                              :selected="fields.property_type === 'building'"
                              >
                              Stavba
                          </option>
                          <option
                              :value="'parcel'"
                              :selected="fields.property_type === 'parcel'"
                              >
                              Parcela
                          </option>
                      </select>
                  </div>
              </div>
          </div>
        <div v-else class="row">
          <div class="col-md-4">
            <radio-image-button
                :name="'property_type'"
                :value="'unit'"
                id="unit"
                :propertyName="$t('property_type.unit')"
                :image="'flat'"
                :selected="fields.property_type === 'unit'"
                @update:value="(value) => fields.property_type = value"
            ></radio-image-button>
          </div>
          <div class="col-md-4">
            <radio-image-button
                :name="'property_type'"
                :value="'building'"
                id="building"
                :propertyName="$t('property_type.building')"
                :image="'house'"
                :selected="fields.property_type === 'building'"
                @update:value="(value) => fields.property_type = value"
            ></radio-image-button>
          </div>
          <div class="col-md-4">
            <radio-image-button
                :name="'property_type'"
                :value="'parcel'"
                id="parcel"
                :propertyName="$t('property_type.parcel')"
                :image="'land'"
                :selected="fields.property_type === 'parcel'"
                @update:value="(value) => fields.property_type = value"
            ></radio-image-button>
          </div>
        </div>
      </div>
    </div>
    <div class="card border-0 mb-4">
      <div class="card-body">
        <div class="row no-gutters mb-4">
          <div class="col d-flex flex-row">
            <div class="dropdown show z-index-4030">
              <a class="btn btn-dropdown dropdown-toggle" href="#" role="button"
                 id="purchaseStateDropdownLink" data-toggle="dropdown" aria-haspopup="true"
                 aria-expanded="false">
                <span v-if="fields.purchase_state === 'all'">{{ $t('data.all_data') }}</span>
                <span v-else>{{ $t('data.purchased_only') }}</span>
              </a>
              <div class="dropdown-menu purchase-state-dropdown" aria-labelledby="purchaseStateDropdownLink">
                <a class="dropdown-item" href="#" data-value="all" @click="getPurchaseState($event.target)">{{ $t('data.all_data') }}</a>
                <a class="dropdown-item" href="#" data-value="purchased" @click="getPurchaseState($event.target)">{{ $t('data.purchased_only') }}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="district">{{ $t("parameters.district") }}:</label>
              <district-select
                  @update:value="(value) => fields.district = value"
                  :selected="fields.district"
                  :error="form !== null && form.errors.has('district')"
              ></district-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="district">{{ $t("parameters.village") }}:</label>
              <city-select
                  :district="fields.district"
                  :selected="fields.city"
                  @update:value="(value) => fields.city = value"
                  :error="form !== null && form.errors.has('city')"
              ></city-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="district"
                     :class="{'form-label is-invalid': form !== null && form.errors.has('unit')}"
                     >{{ $t("parameters.cadastre_area") }}: *</label>
              <unit-select
                  :district="fields.district"
                  :city="fields.city"
                  :selected="fields.unit"
                  @update:value="(value) => fields.unit = value"
                  :error="form !== null && form.errors.has('unit')"
              ></unit-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-row">
              <div class="col-md-12 input-group-from-to">
                <label class="form-label"
                       :class="{'is-invalid': form !== null
                                   && ((form.errors.has('date_from') || form.errors.has('date_to'))
                                   || (form.errors.has('date_difference')))
                               }"
                >{{ $t("parameters.period") }}</label>
                <div class="custom-input-group input-group"
                     :class="{'is-invalid': form !== null
                        && (form.errors.has('date_from') || form.errors.has('date_to'))
                      }">
                  <div class="input-group-prepend">
                    <div class="w-40 ">
                      <DatePicker :value="fields.month_from"
                                  @update:value="(value) => fields.month_from = value"
                                  :date-type="monthsFrom"
                                  :name="'month_from'"
                                  class="text-right"
                                  :current="fields.month_from">
                      </DatePicker>
                    </div>
                    <div class="w-60">
                      <DatePicker :value="fields.year_from"
                                  @update:value="(value) => fields.year_from = value"
                                  :date-type="years"
                                  :name="'year_from'"
                                  :current="fields.year_from">
                      </DatePicker>
                    </div>
                  </div>
                  <div class="input-group-append">
                    <div class="w-40">
                      <DatePicker :value="fields.month_to"
                                  @update:value="(value) => fields.month_to = value"
                                  :date-type="monthsToList"
                                  :name="'month_to'"
                                  class="text-right"
                                  :current="fields.month_to">
                      </DatePicker>
                    </div>
                    <div class="w-60">
                      <DatePicker :value="fields.year_to"
                                  @update:value="(value) => fields.year_to = value"
                                  :date-type="years"
                                  :name="'year_to'"
                                  :current="fields.year_to">
                      </DatePicker>
                    </div>
                  </div>
                </div>
              </div>
              <span class="ml-2 mt-1 badge badge-danger" v-if="form !== null && form.errors.has('date_difference')">
                {{ form.errors.errors.date_difference[0] }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="fields.property_type !== null" class="card border-0 mb-6">
      <div class="card-body">
        <div class="row">
          <div class="col-md-7">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group" v-if="fields.property_type === 'unit'">
                  <label
                      class="form-label"
                      :class="{'is-invalid': form !== null && form.errors.has('usage')}"
                  >{{ $t("parameters.unit_usage") }}</label>
                  <select2
                      :options="wayOfUses['unit_way_of_use']"
                      :settings="{ allowClear:true, theme: 'bootstrap4', placeholder: $t('buttons.choose') }"
                      v-model="fields.usage"
                  ></select2>
                </div>
                <div class="form-group" v-if="fields.property_type === 'building'">
                  <label
                      class="form-label"
                      :class="{'is-invalid': form !== null && form.errors.has('usage')}"
                  >{{ $t("parameters.building_usage") }}</label>
                  <select2
                      :options="wayOfUses['building_way_of_use']"
                      :settings="{ allowClear:true, theme: 'bootstrap4', placeholder: $t('buttons.choose') }"
                      v-model="fields.usage"
                  ></select2>
                </div>
                <div class="form-group" v-if="fields.property_type === 'parcel'">
                  <label class="form-label">{{ $t("parameters.land_type") }}</label>
                  <select2
                      :options="wayOfUses['parcel_way_of_use']"
                      :settings="{ allowClear:true, theme: 'bootstrap4', placeholder: $t('buttons.choose') }"
                      v-model="fields.usage"
                  ></select2>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-row mb-3 mb-md-0" id="share_block">
                  <div class="col-md-12 input-group-from-to">
                    <label
                        class="form-label"
                        :class="{'is-invalid': form !== null
                          && (form.errors.has('share_from') || form.errors.has('share_to')) }"
                        v-if="fields.property_type === 'unit'"
                    >{{ $t("parameters.share_area") }}</label>
                    <label
                        class="form-label"
                        :class="{'is-invalid': form !== null
                          && (form.errors.has('share_from') || form.errors.has('share_to')) }"
                        v-if="fields.property_type === 'building'"
                    >{{ $t("parameters.parcel_under") }}</label>
                    <label
                        class="form-label"
                        :class="{'is-invalid': form !== null
                          && (form.errors.has('share_from') || form.errors.has('share_to')) }"
                        v-if="fields.property_type === 'parcel'"
                    >{{ $t("parameters.parcel_area") }}</label>
                      <div class="input-group">
                          <input type="number" name="share_from" v-model="fields.share_from" value="" class="form-control border-radius-l-20">
                          <div class="input-group-prepend ml-n-1">
                              <div class="input-group-text bg-white">až</div>
                          </div>
                          <input type="number" name="share_to" v-model="fields.share_to" value="" class="form-control">
                          <div class="input-group-append">
                              <span class="input-group-text">m<sup>2</sup></span>
                          </div>
                      </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5">
                <label class="form-label">{{ $t("parameters.by_pairing") }}</label>
                <div class="mt-2">
                  <div class="row">
                    <div class="col-xl-4">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="paired" v-model="fields.pair_status">
                        <label class="form-check-label" for="pair_status[]">
                            {{ $t("parameters.paired") }}
                        </label>
                      </div>
                    </div>
                    <div class="col-xl-4">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="unpaired" v-model="fields.pair_status">
                        <label class="form-check-label" for="pair_status[]">
                            {{ $t("parameters.to_pair") }}
                        </label>
                      </div>
                    </div>
                    <div class="col-xl-4">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="without-candidates"
                               v-model="fields.pair_status">
                        <label class="form-check-label" for="pair_status[]">
                            {{ $t("parameters.without_candidates") }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
        </div>

        <button type="submit" class="btn btn-primary btn-edge" :disabled="form !== null && form.processing">
          <i class="fas fa-search mr-1"></i>
            {{ $t("buttons.search") }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import DatePicker from "../../includes/DatePicker";
import DistrictSelect from "../../includes/DistrictSelect";
import CitySelect from "../../includes/CitySelect";
import UnitSelect from "../../includes/UnitSelect";
import RadioImageButton from "../../includes/RadioImageButton";
import Select2 from 'v-select2-component';
import Form from 'form-backend-validation';

export default {
  name: "FilterForm",
  components: {RadioImageButton, Select2, CitySelect, DistrictSelect, DatePicker, UnitSelect},
  props: {
    monthsFrom: {
      type: Object,
      required: true
    },
    monthsTo: {
      type: Object,
      required: true
    },
    years: {
      type: Object,
      required: true
    },
    selectedMonthFrom: {
      type: [String, Number],
      required: true
    },
    selectedYearFrom: {
      type: [String, Number],
      required: true
    },
    wayOfUses: {
      type: Object,
      required: false
    },
    old: {
      type: Object,
      required: false
    }
  },
  data: function () {
    return {
      showSelect: false,
      districts: null,
      cities: null,
      units: null,
      monthsToList: this.initializeMonthsTo(),
      propertyChecked: {
        unit: true,
        building: false,
        parcel: false
      },
      fields: {
        purchase_state: this.old?.purchase_state || 'all',
        property_type: this.old?.property_type || 'unit',
        district: this.old?.district,
        city: this.old?.city,
        unit: this.old?.unit,
        month_from: this.old?.month_from || this.selectedMonthFrom,
        year_from: this.old?.year_from || this.selectedYearFrom,
        month_to: this.old?.month_to || this.monthToMethod(),
        year_to: this.old?.year_to || this.yearToMethod(),
        usage: this.old?.usage,
        share_from: this.old?.share_from,
        share_to: this.old?.share_to,
        pair_status: this.old?.pair_status || []
      },
      errors: {},
      form: null,
      dateOptions: ['month_from', 'month_to', 'year_from', 'year_to']
    }
  },
  methods: {
    submit: function () {
      let normalizedFields = this.toLaravelRequest(this.fields);
      this.form = new Form(normalizedFields, {resetOnSuccess: false});
      this.form.post('/cadastre/prices/price-filter')
          .then(response => {
            this.form.errors.clear();
            window.location.href = response.route;
          })
          .catch(errors => {
            document.querySelector('.js-spinner').classList.toggle('d-block');
          });
    },
    getPurchaseState(target) {
      this.fields.purchase_state = target.getAttribute('data-value')
    },
    toLaravelRequest(fields) {
      for (let property in fields) {
        if (fields[property] === null || fields[property] === undefined) {
          delete fields[property];
          continue;
        }
        if (isNaN(parseInt(fields[property])) || this.dateOptions.includes(property)) {
          continue;
        }

        fields[property] = parseInt(fields[property]);
      }

      return fields;
    },
    monthToMethod() {
      return this.monthsTo[Object.keys(this.monthsTo)[Object.keys(this.monthsTo).length - 1]];
    },
    yearToMethod() {
      return this.years[Object.keys(this.years)[Object.keys(this.years).length - 1]];
    },
    initializeMonthsTo() {
        if (this.old?.year_to === null) {
            return this.monthsTo;
        }

        return this.old.year_to == this.years[Object.keys(this.years)[Object.keys(this.years).length - 1]]
            ? this.monthsTo
            : this.monthsFrom;
    },
  },
    mounted() {
        const contentPreloader = document.getElementById('content-preloader');
        contentPreloader.style.display = "none";

        this.showSelectToMaxWidth(767);
    },
  watch: {
    'fields.property_type'() {
      this.fields.usage = null;
    },
    'fields.year_to'() {
      this.monthsToList = this?.fields?.year_to == this.yearToMethod() ? this.monthsTo : this.monthsFrom;
    },
    'fields.district'() {
        if (this.fields.city !== null) {
            this.fields.city = null;
        }
        if (this.fields.unit !== null) {
            this.fields.unit = null;
        }
    },
      'fields.city'() {
          if (this.fields.unit !== null) {
              this.fields.unit = null;
          }
      }

  }
}
</script>

<style scoped>

</style>
